export const CDN_PREFIXES = new Map([
	["galaxycontrol.app", "https://p.fxtools.gl/d/galaxycontrol.app"],
	["dragonlord.games", "https://p.fxtools.gl/d/dragonlord.games"],
	["id.fx.gl", "https://p.fxtools.gl/d/id.fx.gl"],
	["id-dev.fx.gl", "https://p.fxtools.gl/d/id-dev.fx.gl"]
]);
export const CDN_PREFIX = CDN_PREFIXES.get(window.location.host) ?? "";
